import addPrintAction from './lib/add-print-action';
import ready from "./lib/ready";

ready().then(function () {
// force image loading
    addPrintAction(function () {
        Array.prototype.forEach.call(document.querySelectorAll('img[loading="lazy"]'), function (node) {
            node.setAttribute('loading', 'eager');
        });
    });
});